module.exports = __webpack_public_path__ + "media/assets/certification_page/checkmark-74776cf1365b19941e29771cfbe8b8741c558f86ce29fe1ac4d3b86b53bec646.svg";